import { render, staticRenderFns } from "./Theme3TheFooter.vue?vue&type=template&id=464bafc4&scoped=true&"
import script from "./Theme3TheFooter.vue?vue&type=script&lang=js&"
export * from "./Theme3TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./Theme3TheFooter.vue?vue&type=style&index=0&id=464bafc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464bafc4",
  null
  
)

export default component.exports